<mcg-window #pluginsWindow [title]="translate('Plugins')">
  <div class="plugins-list">
    @for (plugin of getPlugins(); track plugin.id) {
      <app-plugin-card [title]="plugin.name" [description]="plugin.description" [imageSrc]="plugin.image" />
    }
  </div>
</mcg-window>
